"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dentalProductApi = require("@/api/dentalProductApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ProductBinding',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    clinicId: {
      type: Number,
      default: null
    },
    clinicName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      listLoading: false,
      searchForm: {
        page: 1,
        limit: 10,
        keyword: '',
        status: null
      },
      productList: [],
      total: 0,
      selectedProducts: []
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler: function handler(val) {
        console.log('ProductBinding - visible changed:', val);
        this.dialogVisible = val;
        if (val && this.clinicId) {
          this.getList();
        }
      }
    },
    dialogVisible: function dialogVisible(val) {
      if (!val) {
        this.$emit('update:visible', false);
      }
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;
      if (!this.clinicId) {
        this.$message.error('请选择诊所');
        return;
      }
      this.listLoading = true;
      var params = {
        page: this.searchForm.page,
        limit: this.searchForm.limit,
        keyword: this.searchForm.keyword,
        status: this.searchForm.status
      };
      (0, _dentalProductApi.getProductsNotInClinic)(this.clinicId, params).then(function (res) {
        console.log('API response:', res);
        // 处理返回的数据
        if (res && res.list) {
          _this.productList = res.list;
          _this.total = res.total || 0;
        } else {
          _this.productList = [];
          _this.total = 0;
        }

        // 确保图片和标签是数组格式
        _this.productList.forEach(function (product) {
          if (typeof product.imageList === 'string') {
            product.imageList = product.imageList.split(',').filter(function (url) {
              return url && url.trim() !== '';
            });
          } else if (!Array.isArray(product.imageList)) {
            product.imageList = [];
          }
          if (typeof product.tagList === 'string') {
            product.tagList = product.tagList.split(',').filter(function (tag) {
              return tag && tag.trim() !== '';
            });
          } else if (!Array.isArray(product.tagList)) {
            product.tagList = [];
          }
        });
      }).catch(function (error) {
        console.error('获取商品列表失败:', error);
        _this.$message.error('获取商品列表失败');
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        page: 1,
        limit: 10,
        keyword: '',
        status: null
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedProducts = selection;
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    confirmBinding: function confirmBinding() {
      var _this2 = this;
      if (this.selectedProducts.length === 0) {
        this.$message.warning('请至少选择一个商品');
        return;
      }
      var data = {
        clinicId: this.clinicId,
        productIds: this.selectedProducts.map(function (item) {
          return item.id;
        })
      };
      this.listLoading = true;
      (0, _dentalProductApi.bindProductsToClinic)(data).then(function () {
        _this2.$message.success("\u6210\u529F\u7ED1\u5B9A".concat(_this2.selectedProducts.length, "\u4E2A\u5546\u54C1"));
        _this2.$emit('success');
        _this2.$emit('update:visible', false);
      }).catch(function (error) {
        console.error('绑定商品失败:', error);
        _this2.$message.error('绑定商品失败');
      }).finally(function () {
        _this2.listLoading = false;
      });
    }
  }
};